/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export class CheckboxButtonGroup extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectedOption: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
    allowMultiSelect: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    allowMultiSelect: false,
    className: ''
  }

  render() {
    let { id, label, options, selectedOption, onChange, allowMultiSelect, className } = this.props

    return (
      <fieldset className={`slds-form-element ${className}`}>
        {label &&
          <legend className="slds-form-element__legend slds-form-element__label">
            {label}
          </legend>
        }
        <div className="slds-form-element__control">
          <div className="slds-checkbox_button-group">
            {options.map(option => (
              <span
                className="slds-button slds-checkbox_button"
                key={`checkbox-buttongroup_${option}`}>
                <input
                  id={`${id}_${option}`}
                  type="checkbox"
                  name="checkbox"
                  value={option}
                  checked={allowMultiSelect
                    ? selectedOption.includes(option)
                    : selectedOption === option
                  }
                  onChange={onChange}
                />
                <label className="slds-checkbox_button__label" htmlFor={`${id}_${option}`}>
                  <span className="slds-checkbox_faux">{option}</span>
                </label>
              </span>
            ))}
          </div>
        </div>
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/checkbox-button-group/index.js